import React, { useContext, useEffect, useState } from "react";
import ReactExport from "react-data-export";
import { Button } from "@material-ui/core";
import { ReportERPContext } from "../../context/ReportERPContext";
import "../../styles/global.css";

const ExcelFile = ReactExport.ExcelFile;
const ExcelSheet = ReactExport.ExcelFile.ExcelSheet;

const ExportExcel = () => {
  const { valuesTable } = useContext(ReportERPContext);
  const [dataExcel, setDataExcel] = useState([]);
  const [styleButton, setStyleButton] = useState({});

  useEffect(() => {
    setStyleButton({ display: "none" });

    const allColumns = [
      "Empresa",
      "Base",
      "QtdClientes",
      "QtdFornecedores",
      "QtdProdutos",
      "QtdPedidos",
      "ValorPedidos",
      "QtdNFe",
      "ValorNFe",
      "QtdNFSe",
      "ValorNFSe",
      "QtdBoletoRec",
      "ValorBoletoRec",
      "QtdCCreditoRec",
      "ValorCCreditoRec",
      "QtdCDebitoRec",
      "ValorCDebitoRec",
      "QtdDinheiroRec",
      "ValorDinheiroRec",
      "QtdBoletoPag",
      "ValorBoletoPag",
      "QtdCCreditoPag",
      "ValorCCreditoPag",
      "QtdCDebitoPag",
      "ValorCDebitoPag",
      "QtdDinheiroPag",
      "ValorDinheiroPag",
      "QtdRecebidos",
      "ValorRecebidos",
      "QtdPagos",
      "ValorPagos",
    ];

    const styleTotal = {
      font: { bold: true },
      alignment: { vertical: "center", horizontal: "center" },
      fill: { patternType: "solid", fgColor: { rgb: "c0c0c0" } },
    };

    let totalQtdRecebidos = 0;
    let totalValorRecebidos = 0;

    let totalQtdPedidos = 0;
    let totalValorPedidos = 0;

    let totalQtdNFe = 0;
    let totalValorNFe = 0;

    let totalQtdNFSe = 0;
    let totalValorNFSe = 0;

    let totalQtdPagos = 0;
    let totalValorPagos = 0;

    let totalQtdBoletoRec = 0;
    let totalValorBoletoRec = 0;

    let totalQtdCCreditoRec = 0;
    let totalValorCCreditoRec = 0;

    let totalQtdCDebitoRec = 0;
    let totalValorCDebitoRec = 0;

    let totalQtdDinheiroRec = 0;
    let totalValorDinheiroRec = 0;

    let totalQtdBoletoPag = 0;
    let totalValorBoletoPag = 0;

    let totalQtdCCreditoPag = 0;
    let totalValorCCreditoPag = 0;

    let totalQtdCDebitoPag = 0;
    let totalValorCDebitoPag = 0;

    let totalQtdDinheiroPag = 0;
    let totalValorDinheiroPag = 0;

    const data = [
      ...valuesTable.map(item => {
        totalQtdPagos += item.QtdPagos;
        totalValorPagos += parseFloat(item.ValorPagos);

        totalQtdRecebidos += item.QtdRecebidos;
        totalValorRecebidos += parseFloat(item.ValorRecebidos);

        totalQtdPedidos += item.QtdPedidos;
        totalValorPedidos += parseFloat(item.ValorPedidos);

        totalQtdNFe += item.QtdNFe || 0;
        totalValorNFe += parseFloat(item.ValorNFe || 0);

        totalQtdNFSe += item.QtdNFSe || 0;
        totalValorNFSe += parseFloat(item.ValorNFSe || 0);

        totalQtdBoletoRec += item.QtdBoletoRec || 0;
        totalValorBoletoRec += parseFloat(item.ValorBoletoRec || 0);

        totalQtdCCreditoRec += item.QtdCCreditoRec || 0;
        totalValorCCreditoRec += parseFloat(item.ValorCCreditoRec || 0);

        totalQtdCDebitoRec += item.QtdCDebitoRec || 0;
        totalValorCDebitoRec += parseFloat(item.ValorCDebitoRec || 0);

        totalQtdDinheiroRec += item.QtdDinheiroRec || 0;
        totalValorDinheiroRec += parseFloat(item.ValorDinheiroRec || 0);

        totalQtdBoletoPag += item.QtdBoletoPag || 0;
        totalValorBoletoPag += parseFloat(item.ValorBoletoPag || 0);

        totalQtdCCreditoPag += item.QtdCCreditoPag || 0;
        totalValorCCreditoPag += parseFloat(item.ValorCCreditoPag || 0);

        totalQtdCDebitoPag += item.QtdCDebitoPag || 0;
        totalValorCDebitoPag += parseFloat(item.ValorCDebitoPag || 0);

        totalQtdDinheiroPag += item.QtdDinheiroPag || 0;
        totalValorDinheiroPag += parseFloat(item.ValorDinheiroPag || 0);

        return allColumns.map(key =>
          item[key] || item[key] === 0
            ? {
                value: item[key],
                style: {
                  alignment: { vertical: "center", horizontal: "center" },
                },
              }
            : { value: "" }
        );
      }),
      [
        {
          value: totalQtdPedidos,
          style: styleTotal,
        },
        {
          value: totalValorPedidos.toFixed(2),
          style: styleTotal,
        },
        {
          value: totalQtdNFe,
          style: styleTotal,
        },
        {
          value: totalValorNFe.toFixed(2),
          style: styleTotal,
        },
        {
          value: totalQtdNFSe,
          style: styleTotal,
        },
        {
          value: totalValorNFSe.toFixed(2),
          style: styleTotal,
        },

        {
          value: totalQtdBoletoRec,
          style: styleTotal,
        },
        {
          value: totalValorBoletoRec.toFixed(2),
          style: styleTotal,
        },

        {
          value: totalQtdCCreditoRec,
          style: styleTotal,
        },
        {
          value: totalValorCCreditoRec.toFixed(2),
          style: styleTotal,
        },

        {
          value: totalQtdCDebitoRec,
          style: styleTotal,
        },
        {
          value: totalValorCDebitoRec.toFixed(2),
          style: styleTotal,
        },

        {
          value: totalQtdDinheiroRec,
          style: styleTotal,
        },
        {
          value: totalValorDinheiroRec.toFixed(2),
          style: styleTotal,
        },

        {
          value: totalQtdBoletoPag,
          style: styleTotal,
        },
        {
          value: totalValorBoletoPag.toFixed(2),
          style: styleTotal,
        },

        {
          value: totalQtdCCreditoPag,
          style: styleTotal,
        },
        {
          value: totalValorCCreditoPag.toFixed(2),
          style: styleTotal,
        },

        {
          value: totalQtdCDebitoPag,
          style: styleTotal,
        },
        {
          value: totalValorCDebitoPag.toFixed(2),
          style: styleTotal,
        },

        {
          value: totalQtdDinheiroPag,
          style: styleTotal,
        },
        {
          value: totalValorDinheiroPag.toFixed(2),
          style: styleTotal,
        },
        {
          value: totalQtdRecebidos,
          style: styleTotal,
        },
        {
          value: totalValorRecebidos.toFixed(2),
          style: styleTotal,
        },
        {
          value: totalQtdPagos,
          style: styleTotal,
        },
        {
          value: totalValorPagos.toFixed(2),
          style: styleTotal,
        },
      ],
    ];

    if (data && data[data.length - 1]) {
      for (let i = 0; i < 4; i++) {
        data[data.length - 1].unshift({
          value: "",
          style: styleTotal,
        });

        if (i === 3) {
          data[data.length - 1].unshift({
            value: "TOTAL",
            style: styleTotal,
          });
        }
      }
    }

    const styleColumns = {
      font: { color: { rgb: "ffffff" }, bold: true },
      fill: { fgColor: { rgb: "212121" } },
      alignment: { vertical: "center", horizontal: "center" },
    };

    const columns = allColumns.map(column => {
      return {
        title: column,
        width: { wch: 15 },
        style: styleColumns,
      };
    });

    setDataExcel([{ columns, data }]);
    setStyleButton({});
  }, [valuesTable]);

  return (
    <ExcelFile
      filename={`consumoERP`}
      element={
        <Button className="excel-export-button" style={styleButton}>
          <img src="./img/excel.png" alt="Excel" />
          Exportar
        </Button>
      }
    >
      <ExcelSheet dataSet={dataExcel} name="ConsumoERP"></ExcelSheet>
    </ExcelFile>
  );
};

export default ExportExcel;
